// Global
import React from 'react';

// Local
import { ProductResponse } from 'lib/services/models/content-response';
import styles from './ProductNutrition.module.scss';
import NutritionFacts from 'components/helpers/NutritionFacts';

export interface ProductNutritionProps {
  product: ProductResponse;
}

export function ProductNutrition(_props: ProductNutritionProps) {
  return (
    <div className={styles.productNutrition}>
      <NutritionFacts contentTypeData={_props.product.Nutrition} contentType="product" />
    </div>
  );
}
